/* eslint-disable max-len */
import * as compConfigAPI from '../../api/companyConfigs';

const logoTypeId = '5efa24a180cde9a5cf9e0aa5';
const paletteTypeId = '5dcc5c88e26163f4aceec5de';

const objectIsEmpty = (obj) => !obj || !Object.keys(obj).length;

export const createPaletteConfiguration = async (defaultTheme, _companyName, token) => {
  const companyConfigPalette = await compConfigAPI.getCompanyAndType(_companyName, paletteTypeId, token);
  if (objectIsEmpty(companyConfigPalette)) return defaultTheme;
  const { payload: { palette: paletteConfig, useThemeInModal = false } } = companyConfigPalette;
  if (!useThemeInModal) return defaultTheme;
  const newPalette = {
    primary: paletteConfig.primary,
    secondary: paletteConfig.secondary,
    sidebar: paletteConfig.sidebar || defaultTheme.palette.sidebar,
  };
  return {
    ...defaultTheme,
    palette: newPalette,
  };
};

export const createLogoConfiguration = async (companyID, token) => {
  const companyConfigLogo = await compConfigAPI.getCompanyAndType(companyID, logoTypeId, token);
  if (objectIsEmpty(companyConfigLogo)) return { logo: '', disableLogo: true };

  const { payload: { logo: logoConfig = '', disableLogoInModal = true } } = companyConfigLogo;
  return {
    logo: `url(${logoConfig})`,
    disableLogo: disableLogoInModal,
  };
};
